import React from "react";
import { FormattedMessage } from "react-intl";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Paper,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";

const ProductModal = ({
  open,
  selectedProduct,
  onClose,
  onNotesChange,
  onQuantityChange,
  onAddToCart,
  buildImageUrl,
  fullScreen,
  showCartButton,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={fullScreen}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{selectedProduct ? selectedProduct.name : "Producto"}</span>
        <Box>
          <Tooltip title="Close">
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          p: 0,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            flexGrow: 1,
            height: "50vh",
            overflowY: "auto",
            p: 2,
            mb: 2,
            position: "relative",
          }}
        >
          {selectedProduct ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Box>
                  {selectedProduct.images &&
                    selectedProduct.images.length > 0 && (
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        {selectedProduct.images.map((url, index) => (
                          <img
                            key={index}
                            src={buildImageUrl(url)}
                            alt={selectedProduct.name}
                            style={{
                              width: "100%",
                              height: "auto",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        ))}
                      </Box>
                    )}
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mt: 2 }}
                  >
                    {selectedProduct.description}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color={"#1A1A1A"}
                    sx={{ mt: 1 }}
                  >
                    $
                    {" " +
                      new Intl.NumberFormat("es-AR", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(Number(selectedProduct.price) || 0)}
                  </Typography>
                </Box>
              </Grid>
        
              {showCartButton && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      label={
                        <FormattedMessage
                          id="app.productNotes"
                          defaultMessage="Notas para el producto"
                        />
                      }
                      variant="outlined"
                      size="small"
                      fullWidth
                      multiline
                      rows={3}
                      value={selectedProduct.productNotes || ""}
                      onChange={(e) => onNotesChange(e.target.value)}
                      sx={{ mt: 1 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ textAlign: "center" }}
                    >
                      <IconButton
                        size="small"
                        onClick={() =>
                          onQuantityChange(selectedProduct.quantity - 1)
                        }
                      >
                        <RemoveIcon />
                      </IconButton>
                      <Typography mx={1}>{selectedProduct.quantity ? selectedProduct.quantity : 1}</Typography>
                      <IconButton
                        size="small"
                        onClick={() =>
                          onQuantityChange(selectedProduct.quantity + 1)
                        }
                      >
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sx={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      onClick={() => onAddToCart({
                        product: selectedProduct,
                        quantity: selectedProduct.quantity || 1,
                        productNotes: selectedProduct.productNotes || ''
                      })}
                      sx={{ width: "100%" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="400"
                        color={"#FFFFFF"}
                        sx={{ mt: 0, paddingRight: 1, paddingLeft: 1 }}
                      >
                        Agregar al pedido
                      </Typography>
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          ) : (
            <Typography variant="body2">Producto no disponible</Typography>
          )}
        </Paper>
      </DialogContent>
    </Dialog>
  );
};

export default ProductModal;
